import jwtDecode from "jwt-decode";
import store from "@/state/store";
import { isValid } from "@/helpers/utils/validate";
import { differentTimeMinutes } from "@/helpers/utils/date";
import * as date from "@/helpers/utils/date";
import axios from "axios";
import vueCookies from "vue-cookies";
const qs = require("querystring");

export const validateExpireAccessToken = async (accessToken) => {
  let authProvider = store.getters["auth/getAuthProvider"];
  let refreshToken = store.getters["auth/getOauthRefreshToken"]
  if (isValid(accessToken)) {
    const decoded = jwtDecode(accessToken);
    const exp = decoded.exp;
    if (Date.now() < exp * 1000) {
      return true;
    }
    if (authProvider === "keycloak") {
      return await requestAccessTokenKeycloak()
    }
  } 
  else if (authProvider === "keycloak" && isValid(refreshToken)) {
    return await requestAccessTokenKeycloak()
  }

  return false;
};
export const requestAccessTokenKeycloak = async () => {
  const data = {
    grant_type: "refresh_token",
    refresh_token: store.getters["auth/getOauthRefreshToken"],
  };

  const formData = qs.stringify(data);
  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  return await axios.post(
    `${process.env.VUE_APP_BASE_API}api/v1/Authentications/token/KeyCloak`,
    formData,
    config
  )
  .then(function (result) {
      if (result.status === 201) {
        var decodeRf = getUserInfo(result.data.oauthRefreshToken);
        var decodeAt = getUserInfo(result.data.oauthAccessToken);
        vueCookies.set(
          ".oauth.rt",
          result.data.oauthRefreshToken,
          differentTimeMinutes(decodeRf.exp) * 60
        );
        vueCookies.set(
          ".oauth.at",
          result.data.oauthAccessToken,
          differentTimeMinutes(decodeAt.exp) * 60
        );
        vueCookies.set(
          ".at",
          result.data.accessToken,
          differentTimeMinutes(decodeAt.exp) * 60
        );
        store.dispatch("auth/setAccessToken", { accessToken: result.data.accessToken });
        store.dispatch("auth/setOAuthAccessToken", { oauthAccessToken: result.data.oauthAccessToken });
        store.dispatch("auth/setOAuthRefreshToken", { oauthRefreshToken: result.data.oauthRefreshToken });
        let info = JSON.stringify({
          name: decodeAt.name,
          email: decodeAt.email,
          photo: '',
        });
        vueCookies.set(
          ".oauth.usr",
          info,
          differentTimeMinutes(decodeAt.exp) * 60
        );
        return true;
      }
      return false;
    },
    (error) => {
      console.log(error.response);
      return false
    }
  )
  .catch((error) => {
    // Handle the error
    console.log(error);
    return false
  });
}

export const validateExpiredDateAccessToken = (accessToken) => {
  if (!isValid(accessToken)) {
    return false;
  }

  const decoded = jwtDecode(accessToken);
  const exp = decoded.exp;
  const currentTimestamp = Math.floor(Date.now() / 1000); // เวลาปัจจุบันในรูปแบบ UNIX timestamp (หน่วยวินาที)

  if (exp <= currentTimestamp) {
    // หมดอายุแล้ว
    return false;
  }
  return true;
};

export const getUserInfo = (accessToken) => {
  if (isValid(accessToken)) {
    const decoded = jwtDecode(accessToken);
    return decoded;
  }
  return false;
};
